import Dashboard from "../dashboard/Dashboard";
import GroupCert from "./components/GroupCert";
import GroupEdu from "./components/GroupEdu";
import GroupWorkExp from "./components/GroupWorkExp";
import BasicInfo from "../../components/basic-info/BasicInfo";
import ChipList from "../../components/chip-list/ChipList";
import MicroChipList from "../../components/micro-chip-list/MicroChipList";
import ProfilePhoto from "../../components/profile-photo/ProfilePhoto";
import "../../components/generalComponents.scss";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import RenderDetailButton from "./detail.button";
import {
  getDetails,
  TeacherStatus,
  updateTeacherStatus,
} from "../../services/teacher.service";
import showToast from "../../utils/show.toast";
import { TextArea } from "../../components/basic-info/TextArea";

interface ITeacherDetail {
  firstName: string;
  lastName: string;
  otherNames: string;
  email: string;
  dpUrl: string;
  youtubeVideoUrl: string;
  interests: string[];
  languagesSpoken: ILanguagesSpoken[];
  languagesTaught: ILanguagesToTeach[];
  workExperiences: IWorkExperiences[];
  educationalQualifications: IEducation[];
  otherCertifications: ICertification[];
  aboutYou: string;
  aboutYouAsTeacher: string;
}

interface ILanguagesSpoken {
  language: string;
  proficiency: string;
}

interface ILanguagesToTeach {
  language: string;
  proficiency: string;
}

interface IWorkExperiences {
  title: string;
  company: string;
  endDate: string;
  startDate: string;
  description: string;
}

interface IEducation {
  level: string;
  endDate: string;
  startDate: string;
  institution: string;
  fieldOfStudy: string;
}

interface ICertification {
  name: string;
  issueDate: string;
  issuingOrganization: string;
}

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export default function TeachersDetails() {
  const [TeacherDetail, setTeacherDetail] = useState<ITeacherDetail>({
    firstName: "",
    lastName: "",
    otherNames: "",
    email: "",
    dpUrl: "",
    youtubeVideoUrl: "",
    interests: [],
    languagesSpoken: [],
    languagesTaught: [],
    workExperiences: [],
    educationalQualifications: [],
    otherCertifications: [],
    aboutYou: "",
    aboutYouAsTeacher: "",
  });

  const { teacherId } = useParams();
  const query = useQuery();
  const status = query.get("status");

  const getTeacherDetail = async (teacherId: string | undefined) => {
    try {
      const data = await getDetails<{ result: ITeacherDetail }>(
        `teachers/${teacherId}`
      );
      setTeacherDetail(data.result);
    } catch (error) {
      showToast("Apologies something went datas was not fetched!", false);
    }
  };

  useEffect(() => {
    getTeacherDetail(teacherId);
  }, [teacherId]);

  return (
    <Dashboard pageTitle="Teacher Details">
      <RenderDetailButton
        status={status as TeacherStatus}
        teacherId={teacherId}
        currentStatus={status as string}
        redirectUrl="/teachers/list"
      />

      <div className="section">
        <div className="profile-photo-and-names">
          <ProfilePhoto imageUrl={TeacherDetail.dpUrl} />

          <div className="first-and-last-name">
            <BasicInfo title="First Name" data={TeacherDetail.firstName} />
            <BasicInfo title="Last Name" data={TeacherDetail.lastName} />
          </div>
        </div>

        <div className="more-profile-info">
          <BasicInfo title="Other name" data={TeacherDetail.otherNames} />
          <BasicInfo title="Email Address" data={TeacherDetail.email} />
          <BasicInfo
            title="YouTube URL"
            type="url"
            data={TeacherDetail.youtubeVideoUrl}
          />

          {/* <ChipList title="Interests" data={TeacherDetail.interests} /> */}
          <ChipList
            title="Spoken Language(s)"
            dataObj={TeacherDetail.languagesSpoken}
          />
          <MicroChipList
            title="Language(s) To Teach"
            data={TeacherDetail.languagesTaught}
          />
        </div>
      </div>

      <div>
        {TeacherDetail.workExperiences.map((experience) => (
          <GroupWorkExp data={experience} />
        ))}
      </div>

      <div>
        {TeacherDetail.educationalQualifications.map((edu) => (
          <GroupEdu data={edu} />
        ))}
      </div>

      <div className="section">
        <div className="more-profile-info">
          {/* <BasicInfo title="" data={} /> */}
          <TextArea lable="About Me" value={TeacherDetail.aboutYou} />
          <TextArea
            lable="Me As A teacher"
            value={TeacherDetail.aboutYouAsTeacher}
          />
        </div>
      </div>

      <div>
        {TeacherDetail.otherCertifications.map((cert) => (
          <GroupCert data={cert} />
        ))}
      </div>
    </Dashboard>
  );
}
